<div class="media-body ms-1">
    <a href="javascript:void(0);" class="fw-bold text-overflow text-primary mb-0" (click)="navigateToCCDetails()">
        {{ dataItem && columnOptions &&  dataItem[columnOptions.field] ? dataItem[columnOptions.field] : dataItem[columnOptions.field] }}
    </a>

</div>